import React, { ComponentType } from 'react'

export const EmptyState: ComponentType<{ text: string }> = ({ text }) => {
  return (
    <div className="text-muted text-center" style={{ padding: '230px 0' }}>
      {text}
    </div>
  )
}
